import base from './base'

export default {
//上传图片/文件
  img: {
    upload: `${base.url}/cloud/qiniuUpload/upload`,
  }
};


